<template>
  <ThemeDefaultLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :categories="asyncCategory?.categoryButtonItems"
    :event-name="eventName"
    :category-event-name="categoryEventName"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <div v-if="galleries.length > 0">
      <ThemeDefaultCardGalleryDisplay
        :items="galleries"
        action-event-name="Preview"
        fb-event-name="Gallery"
        event-name="preview"
      />
      <Pagination
        v-model="page"
        :total="total"
        :per-page="perPage"
      />
    </div>
    <LandingNoData v-else />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  categoryEventName,
  eventName,
  breadcrumbs,
  asyncCategory,
  page,
  perPage,
  total,
  galleries,
} = await useGalleryPage()
</script>
